import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  //Your web app's Firebase configuration

  apiKey: "AIzaSyDTqGgT_1V9VEM13a2uTBltZg5YLqusoaI",
  authDomain: "events-reminder-83889.firebaseapp.com",
  projectId: "events-reminder-83889",
  storageBucket: "events-reminder-83889.appspot.com",
  messagingSenderId: "1056676186358",
  appId: "1:1056676186358:web:ae82e054ad50bb3a39c4d7",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };

export default !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();
